import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "PeriodoAcademicoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "BancoPage",
            ss: ss,
            ajax: {
                "url": ss.indexPeriodoAcademico(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'PeriodoAcademico', name: 'PeriodoAcademico', title: 'Periodo Académico' },
                { data: 'NivelAcademico', name: 'NivelAcademico', title: 'Nivel Académico' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                { data: 'Gestion', name: 'Gestion', title: 'Gestion' },
                { data: 'Periodo', name: 'Periodo', title: 'Periodo' },
                { data: 'FechaInicio', name: 'FechaInicio', title: 'FechaInicio' },
                { data: 'FechaFin', name: 'FechaFin', title: 'FechaFin' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            periodoacademicos: [],
            periodoacademico: {},

            nivelacademicos: [],
            nivelacademico: {},


            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        getNivelAcademico() {
            this.ss.listNivelAcademico().then(
                (result) => {
                    let response = result.data;
                    this.nivelacademicos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newPeriodoAcademico() {
            this.periodoacademico = {};
            this.$refs['frm-periodoacademico'].show();
        },
        showPeriodoAcademico(id) {
            this.isLoading=true;
            this.ss.showPeriodoAcademico(id).then(
                (result) => {
                    let response = result.data;
                    this.periodoacademico = response.data;
                    this.$refs['view-periodoacademico'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editPeriodoAcademico() {
            this.$refs['frm-periodoacademico'].show();
            this.$refs['view-periodoacademico'].hide();
        },
        cancelPeriodoAcademico() {
            if (this.periodoacademico.id) {
                this.$refs['view-periodoacademico'].show();
            }
            this.$refs['frm-periodoacademico'].hide();
        },
        savePeriodoAcademico() {
            this.ss.storePeriodoAcademico(this.periodoacademico).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-periodoacademico'].hide();
                    this.$refs['datatable-periodoacademico'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deletePeriodoAcademico() {
            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "¿Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyPeriodoAcademico(this.periodoacademico)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-periodoacademico'].hide();
                                this.$refs['datatable-periodoacademico'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-PeriodoAcademico').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showPeriodoAcademico(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));

        this.getNivelAcademico();

        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
